var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoveDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#3B66B0;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M3.2,20.7v-2.2h3l-0.4-0.4c-0.9-0.9-1.5-1.8-1.9-2.9s-0.6-2.1-0.6-3.2c0-2,0.6-3.8,1.8-5.3s2.8-2.6,4.7-3.1 v2.3C8.4,6.4,7.4,7.2,6.6,8.3s-1.2,2.4-1.2,3.8c0,0.8,0.2,1.6,0.5,2.4s0.8,1.5,1.4,2.1l0.3,0.3v-2.7h2.2v6.5H3.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M18.9,5.6v3.9H15V5.6H18.9 M20.9,3.6H13v7.9h7.9V3.6L20.9,3.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M18.9,14.8v3.9H15v-3.9H18.9 M20.9,12.8H13v7.9h7.9V12.8L20.9,12.8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoveDown);
export default __webpack_public_path__ + "static/media/move-down.cd30036c4d7482c726bd0ed8bcbd545b.svg";
export { ForwardRef as ReactComponent };